<template>
  <CRow>
    <CCol col="12">
      <!-- <label v-if="label">{{ label }}</label> -->

      <div class ="flow-align">
      
        <multiselect
          v-model="selValueModel"
          :track-by="ctrlCode"
           placeholder="Select"
            :options="options"
            :searchable="isSearchable"
        :multiple="isMultiple"
        :allow-empty="isAllowEmpty"
        :taggable="false"
          :custom-label="customLabel"          
          @input="onChange"
          deselectLabel=""
        deselectGroupLabel=""
        selectLabel=""
        selectedLabel=""
         
        >
        <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
          <!-- <template slot="singleLabel" slot-scope="{ option }">
            <div>{{ option[ctrlName] }}</div>
          </template>
          <template slot="option" slot-scope="props">
            <div class="d-flex">
              <div>
                <span>{{ props.option[ctrlName] }}</span>
              </div>
              <strong class="right ml-auto" v-if="isShowCode">
                {{
                props.option[ctrlCode]
                }}
              </strong>
            </div>
          </template> -->
          <!-- <template #noResult>
                <strong >
                  <div>
                  {{resultEmpty}}</div>
                  <br/>
                  
                  <div v-if="isAddCountry" >
                  <CButton @click="emitAddCountry()">{{buttonName}}</CButton>
                  </div>
                </strong>
              </template>
              <template #noOptions>
                <strong >
                  
                  <div>
                  {{optionEmpty}}</div>
                  <br/>
                 
                  <div v-if="isAddCountry" >
                  <CButton @click="emitAddCountry()">{{buttonName}}</CButton>
                  </div>
                </strong>
          </template>-->
        </multiselect>
        <!-- {{ errors[0] }} -->
      </div>
    </CCol>
  </CRow>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import Multiselect from "vue-multiselect";
import { mapGetters, mapActions } from "vuex";
import {
  PATHNAME,
  COMPONENT_NAME,
  DEFAULT_DROPDOWN_STATUS,
  PAX_TITLE
} from "../../util/constants.js";
import BaseConfiguration from "../../config/base.js";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage
} from "../../util/apiValidate.js";
import { handleJWT, getErrorAlertValue, cloneData } from "../../util/util";
import SERVICE_URL from "../../config/API_DATA";
import Logger from "../../services/logger";
import router, { navigate, goBack } from "../../router/index";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";
export default {
  name:COMPONENT_NAME.C_MONTH_DROPDOWN,
  components: {
    ValidationProvider,
    Multiselect
  },
  model: {
    prop: "selValue"
  },

  props: {
    isDisable: {
      type: Boolean,
      default: false
    },
    isManageUser: {
      type: Boolean,
      default: false
    },

    selValue: {
      type: Object | Array,
      default: null
    },
    // isCancelled: {
    //   type: Boolean,
    //   default: false
    // },
    isAllowEmpty: {
      type: Boolean,
      default: false
    },

    isShowCode: {
      type: Boolean,
      default: false
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    isSearchable: {
      type: Boolean,
      default: false
    },
    ctrlName: {
      type: String,
      default: ""
    },

    ctrlCode: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    options: [],
    selected: false,
    selValueModel: null,
   
    noAgents: false,
    alertValue: null
  }),

  async created() {
    // alert(this.paxType);

    this.selValueModel = this.selValue;
    this.options = this.getDpOptions();
  },

  watch: {
    //this.selValueModel = this.selValue;
    selValue(val) {
      if (val !== this.selValueModel) {
        this.selValueModel = val;
      }
    }
  },
  computed: {
    ...mapGetters("language", {
      lang: "GET_LANGUAGE"
    })
  },

  methods: {
    ...mapActions("sStateList", ["SET_STATE_REQ"]),

    customLabel(option) {
      return `${option.monthName + " " + option.year} `;
    },

    onChange(newVal) {
      this.$emit("input", newVal);
    },

    getDpOptions() {
      let retValue = [];
      let monthName = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getDpOptions");
        monthName = [
          
            this.$t("flightDatePicker.jan"),
            this.$t("flightDatePicker.feb"),
            this.$t("flightDatePicker.mar"),
            this.$t("flightDatePicker.apr"),
            this.$t("flightDatePicker.may"),
            this.$t("flightDatePicker.jun"),
            this.$t("flightDatePicker.july"),
            this.$t("flightDatePicker.aug"),
            this.$t("flightDatePicker.sep"),
            this.$t("flightDatePicker.oct"),
            this.$t("flightDatePicker.nov"),
            this.$t("flightDatePicker.dec")
        ];
        var d = new Date();
        d.setDate(1);
        for (let i = 0; i <= 11; i++) {
          let monthObj = {
            month: i,
            monthName: monthName[d.getMonth()],
            monthNumber:null,
            year: d.getFullYear()
          };
          monthObj.monthNumber = monthName.indexOf(monthObj.monthName)+1; 
           monthObj.monthNumber = ('0' + monthObj.monthNumber).slice(-2) 
          retValue.push(monthObj);
          d.setMonth(d.getMonth() - 1);
        }
        if (!this.selValueModel) {
          this.selValueModel = retValue[0];
        }
        this.onChange(this.selValueModel);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_MONTH_DROPDOWN,
          "error in getDpOptions",
          err.toString(),
          "getDpOptions",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    }
  }
};
</script>